<section class="adx-logout-container">
    <mat-card class="adx-logout-card">
        <mat-card-header>
            <mat-card-title >
                <fa-icon [icon]="['fas','right-from-bracket']"></fa-icon>
                {{ 'YOU_HAVE_BEEN_LOGGED_OUT' | translate }}
            </mat-card-title>
        </mat-card-header>
        <mat-card-content class="adx-logout-content-container">
            <p >{{ 'REDIRECT_TO_LOGIN_IN' | translate }} <strong>{{ countdown }}</strong> {{ 'SECONDS' | translate }}...</p>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </mat-card-content>
    </mat-card>
</section>
